import React from "react";
import { SectionCta } from "../SectionCta";
import { painPoints } from "../../data/clinicalDecisions";
export function PainPointsSection() {
  return <section className="w-full bg-white px-5 py-16 sm:py-24" data-id="element-331" data-mp="16t32x0zfc6xv">
      <div className="mx-auto max-w-5xl" data-id="element-332" data-mp="1bmxo68uogtz2">
        <h2 className="text-center font-serif text-[28px] font-black leading-tight text-navy sm:text-4xl" data-id="element-333" data-mp="1bo8p80wqnnmh">
          Does Any of This Sound Familiar?
        </h2>
        <p className="mx-auto mt-4 max-w-2xl text-center text-lg text-muted" data-id="element-334" data-mp="jw1hxr34hnkr">
          If you’ve ever experienced one of these situations, this educational system was designed with
          those challenges in mind.
        </p>

        <ol className="mt-10 grid gap-x-10 gap-y-8 md:grid-cols-2" data-id="element-335" data-mp="sxhg90gnxz8m">
          {painPoints.map((p, i) => <li key={p.title} className="flex gap-4 border-t border-navy/10 pt-6" data-id="element-336" data-mp="xs518pcgkbig" data-mpi={i}>
              <span className="font-serif text-4xl font-black leading-none text-wine" data-id="element-337" data-mp="24co2oj081xvp">{i + 1}</span>
              <div data-id="element-338" data-mp="29br6k04gty23">
                <p className="text-lg font-bold leading-snug text-navy" data-id="element-339" data-mp="2r316jea0p6c3">{p.title}</p>
                <p className="mt-2 text-base text-muted" data-id="element-340" data-mp="2r0oufhqxxq6y">{p.text}</p>
              </div>
            </li>)}
        </ol>

        <SectionCta label="This is exactly what I need" data-id="element-341" data-mp="2i1tmo189081j" />
      </div>
    </section>;
}